const transformToUpdateDietExcludedIngredientsDetailsArgs = data =>
  data?.dietExcludedIngredientIds

export default transformToUpdateDietExcludedIngredientsDetailsArgs
